module.exports = __webpack_public_path__ + "img/کلاسیک.59d1e604.jpg";